import React from 'react'
import "./Companies.css" 
const Companies = () => {
  return (
   <section className="c-wrapper">
    <div className="paddings innerWidth flexCenter c-container">

    <img src="./Images/prologis.png" alt="prologis" />

    <img src="./Images/tower.png" alt="tower" />

    <img src="./Images/equinix.png" alt="equinix" />

    <img src="./Images/realty.png" alt="reality" />

    </div>
   </section>
  )
}

export default Companies